import React from 'react';
import { connect } from 'react-redux';
import HTMLReport from '../components/HTMLReport/HTMLReport';
import Breadcrumb from '../components/Common/Breadcrumb';

const Report = (reportDetails) => {
  const details = reportDetails?.reportDetails || {};
  return (
    <React.Fragment>
      <Breadcrumb
        items={[
          { label: 'Reports', link: '/reports' },
          { label: details?.name, link: `/report/${details?.organisationId}/${details?.id}` },
        ]}
      />

      <HTMLReport />
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({ reportDetails: state?.report?.details });
const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Report);
